import { sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

export function useEventDirectory(eventId, options = {}) {
    const { filter, sortBy: sortFunction } = options,
        directorySelector = useCallback((state) => state.events[eventId]?.directory.all, [eventId]),
        indexedDirectory = useSelector(directorySelector),
        directory = useMemo(() => Object.values(indexedDirectory), [indexedDirectory]);

    return useMemo(() => {
        let result = directory;

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);

        return result;
    }, [directory]);
}
